
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import AddList from './add-list.vue'
import { learnStatus } from '../../utils/publish'
import AddListCustomer from './add-list-customer.vue'
import ListDetail from './list-detail.vue'
import PacketBaseCourse from './packet-base-course.vue'
import StudentInfo from '../studentDeatil/student-info.vue'
import OrderInfo from '../../views/order/details.vue'
import EmployeeInfo from '../../views/employee/detail.vue'
import CampusInfo from '../../views/campus/detail.vue'
import ListWeight from './list-weight.vue'
import AddStorage from '../goods/add-storage.vue'
import GoodsDetails from '../goods/goods-details.vue'
import axios from 'axios'

@Component({
    components: { AddList, ListDetail, StudentInfo, OrderInfo, EmployeeInfo, CampusInfo, ListWeight, AddListCustomer, AddStorage, GoodsDetails, PacketBaseCourse },
    filters: {
        formatDate: function (value, type) {
            if (!value) {
                return
            }
            let date = new Date(value * 1000)
            let y = date.getFullYear()
            let MM: any = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d: any = date.getDate()
            d = d < 10 ? ('0' + d) : d
            let h: any = date.getHours()
            let next_h: any = h < 10 ? ('0' + (h + 1)) : (h + 1)
            h = h < 10 ? ('0' + h) : h
            let m: any = date.getMinutes()
            m = m < 10 ? ('0' + m) : m
            let s: any = date.getSeconds()
            s = s < 10 ? ('0' + s) : s
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m
        }
    }
})
export default class CourseList extends Vue {
    @Prop() list: any
    @Prop() pageName: string
    @Prop() header: any
    @Prop() page: any
    @Prop() optionId: any
    @Prop() upId: string
    @Prop() allData: any


    searchHeight: number = 0
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    tableHeight: number = 0
    optionList: any = []
    bottonOption: any = {
        '1': 'primary',
        '2': 'danger',
        '4': 'primary',
        '5': 'success',
        '6': 'primary'
    }
    upListId: string = ''
    searchList: any = [] // 搜索 string
    selectList: any = [] // 筛选 dict
    keyList: any = [] // 筛选 key_value / foreign-key
    booleanList: any = [] // 筛选 boolean
    numberList: any = [] // 筛选 number
    timeList: any = [] // 筛选 time

    searchCondition: any = [] // 请求数据筛选项
    isDown: boolean = false
    listHeader: any = []
    modifyHeader: any = []
    numberOption: any = [{ 'key': 0, 'value': '否' }, { 'key': 1, 'value': '是' }]
    dialogAdd: boolean = false
    isAddType: string = ''
    isAddButton: boolean = false
    itemValue: any = {}
    isSearch: boolean = false
    from: any = ''
    // 主题要点
    dialogListDetail: boolean = false
    // 套餐关联基础课程设置弹窗
    dialogPacketBaseCourse: boolean = false
    packetBasecourseTitle: string = ''
    packetBasecourseName: string = ''
    packetBasecourseID: string = ''
    packetBasecourseType: string = ''
    packetBasecourseList: any = []
    packetBasecourseHeader: any = []
    defaultCourseId: string = ''

    listDetailId: string = ''
    listDetailType: string = ''
    detailTitle: string = ''
    detailHeader: any = []
    detailList: any = []
    is_student_site: boolean = false
    alert: any = ''
    listPage: any = {}
    sortItem: any = {}
    is_show_export: boolean = false
    is_export_table: boolean = false
    is_option_edit: boolean = false
    is_option_details: boolean = false
    option_edit_data: any = {}
    option_details_data: any = {}
    history_select: any = {}
    is_show_student_info: boolean = false
    student_info_id: any = ''

    pagination_page = 1

    is_show_order_info: boolean = false
    order_info_id: any = ''
    is_show_employee_info: boolean = false
    employee_info_id: string = ''

    is_show_campus_info: boolean = false
    campus_info_id: string = ''
    sort_color: any = ['#FFFFFF', '#2ED05E', '#ECC647', '#F33030']
    // list_copy: any = []
    select_list_data: any = {}  // 所选一行数据
    isMap: boolean = false // 是否展示地图按钮

    customer_optionId: any = ''
    customer_pageName: string = ''
    customer_allData: any = []
    customer_modifyHeader: any = []
    customer_optionList: any = []
    customer_itemValue: any = {}
    customer_isAddType: string = 'edit'
    customer_dialogAdd: boolean = false
    is_popover_show: boolean = true
    is_popover_hide: boolean = false

    storageShow: boolean = false
    goodsItem: any = {}
    goodsSelectId: any = []
    dialogGoodsInfo: boolean = false
    GoodsDetailsInfo: any = {}
    goodsPageType: string = ''
    loading: boolean = true
    is_model: boolean = true

    @Watch('upId')
    getUpListId(val) {
        this.upListId = val
    }
    @Watch('optionId')
    getOption(oldValue, newValue) {
        this.isDeleteButton()
        this.option()
    }
    @Watch('list')
    getList(oldValue, newValue) {
        if (this.pageName === 'edu-order-page') {
            for (var i = 0; i < this.list.length; i++) {
                Vue.set(this.list[i], 'order_number_custom', false)
            }
        }

        if (this.list.length > 0) {
            for (var i = 0; i < this.list[0]['options'].length; i++) {
                if (this.list[0]['options'][i].button_type === 1) {  // edit
                    this.is_option_edit = true
                    this.option_edit_data = this.list[0]['options'][i]
                } else if (this.list[0]['options'][i].button_type === 4 || this.list[0]['options'][i].button_type === 6) { // details
                    this.is_option_details = true
                    this.option_details_data = this.list[0]['options'][i]
                }
            }
        }

        // this.list_copy = this.list
        this.loading = false
    }

    @Watch('header')
    roleHeader(val) {
        this.history_select = this.allData.history_select ? this.allData.history_select : []
        this.listPage = this.page
        this.listHeader = []
        for (var i = 0; i < val.length; i++) {
            const existsType: string = val[i].exists_type
            if (existsType.indexOf('list') >= 0) {
                if (val[i].key != 'id') {
                    this.listHeader.push(val[i])
                }
            }
        }
    }

    getHaderWidth(key) {
        if (this.pageName === 'edu-feedback-page' && key === 'is_handle') {
            return '180'
        } else if (this.pageName === 'edu-order-page' && key === 'number') {
            return '180'
        } else if (this.pageName === 'edu-business-page' && key === 'name' || this.pageName === 'edu-business-page' && key === 'customer_id') {
            return '200'
        } else if (this.pageName === 'edu-goods-page' && key === 'status') {
            return '300'
        } else if (this.pageName === 'edu-goods-use-page' && key === 'info2_status') {
            return '180'
        } else if (this.pageName === 'edu-goods-sale-page' && key === 'info_status') {
            return '180'
        } else if (this.pageName === 'edu-clue-page' && key === 'is_handle') {
            return '180'
        } else if (this.pageName === 'edu-business-page' && key === 'is_connect') {
            return '180'
        } else if (this.pageName === 'edu-student-page' && key === 'student_name') {
            return '180'
        } else {
            return '150'
        }
    }
    //  公共更新列表方法
    updateList() {
        const data: any = {
            page: {
                page: this.pagination_page,
                size: '20'
            },
            org_id: this.org_id,
            search_condition: this.searchCondition
        }
        // this.is_export_table = false
        this.upList(data)
    }
    // 添加仓储物品管理
    addStorage(val) {
        if (val.type) {
            this.is_export_table = false
            this.updateList()
        }
        this.storageShow = false
    }
    //  当前行增加背景色 (暂定)
    tableRowClassName({ row, rowIndex }) {
        if (row.learn_status) {
            // 1 临近到期 2 已到期 3 临近续课时
            if (row.learn_status === 1) {
                return 'color_D8D8F7'
            } else if (row.learn_status === 2) {
                return 'color_F9E3E3'
            } else if (row.learn_status === 3) {
                return 'color_E0FBFB'
            } else if (row.learn_status === 4) {
                return 'color_F9E3E3'
            } else if (row.learn_status === 5) {
                return 'color_F9E3E3'
            } else if (row.learn_status === 6 ){
                return 'color_F9E3E3'
            }
        }
    }

    async goOrderList(val) {
        const data = [{
            field_name: "other_name",
            search_type: 0,
            table_name: "",
            value: [val.id]
        }]
        const page_key = 'edu-order-page'
        const res: any = await CourseModule.setHistory({ data: data, page_key: page_key })
        if (res.code === 200) {
            this.$router.push('/customer/order')
        }
    }

    getSortNumber(val) {
        this.select_list_data = val
        for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].id === val.id) {
                if (val.order_number_custom) {
                    Vue.set(val, 'order_number_custom', false)
                } else {
                    Vue.set(val, 'order_number_custom', true)
                }
            } else {
                Vue.set(this.list[i], 'order_number_custom', false)
            }
        }
    }
    // 导出物品列表
    exportGoodsList() {
        this.is_export_table = true
        this.onSearch()
    }
    // 去地图页面
    getMap() {
        this.$router.push({ path: '/map' })
    }
    // 导出数据 
    exportTable() {
        this.is_export_table = true
        this.onSearch()
    }

    async selectSort(val) {
        const data = {
            id: this.select_list_data.id,
            sort_color: val.id,
            page_name: this.pageName
        }
        const res: any = await CourseModule.updateSortColor(data)
        if (res.code === 200) {
            const list = {
                page: {
                    page: '1',
                    size: '20'
                },
                org_id: this.org_id,
                search_condition: this.searchCondition
            }
            this.is_export_table = false
            this.upList(list)
        }
    }
    getWeight(val) {
        this.selectSort(val)
    }

    // 搜索
    changeSearch() {
        this.is_export_table = false
        this.pagination_page = 1
        this.onSearch()
    }
    // 时间搜索
    changeTimeSearch(val) {
        this.timeList[0].model[1] = new Date(Date.parse(<any>new Date(this.timeList[0].model[1])) + 24 * 60 * 60 * 1000 - 1000)
        this.is_export_table = false
        this.pagination_page = 1
        this.onSearch()
    }

    closeStudent(val) {
        if (val) {
            this.is_show_student_info = true
        } else {
            this.is_show_student_info = false
        }

    }
    closeOrder() {
        this.is_show_order_info = false
    }
    closeEmployee() {
        this.is_show_employee_info = false
    }
    closeCampus() {
        this.is_show_campus_info = false
    }

    forReset(val, type) {
        if (val.length <= 0) {
            return false
        }
        for (var i = 0; i < val.length; i++) {
            if (type === 1) {
                val[i].model = ''
            } else if (type === 2 || type === 3 || type === 6) {
                val[i].model = []
            } else if (type === 4) {
                val[i].model = ''
            } else if (type === 5) {
                val[i].model = 0
            }
        }

    }
    // 重置按钮
    onReset() {
        this.forReset(this.searchList, 1)
        this.forReset(this.selectList, 2)
        this.forReset(this.keyList, 3)
        this.forReset(this.booleanList, 4)
        this.forReset(this.numberList, 5)
        this.forReset(this.timeList, 6)
        this.is_export_table = false
        this.onSearch()
    }
    async onBatchDelete() {
        const res:any = await UserModule.deleteFeedback(this.goodsSelectId)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            await UserModule.GetFeedbackNumber()
            this.updateList()
        }
    }

    alertPop() {
        if (this.alert === 'table') { // 新建订单
            this.addItem()
        }
    }

    getSearchHistory(val) {
        this.history_select = this.allData.history_select ? this.allData.history_select : []
        for (var k = 0; k < this.history_select.length; k++) {
            if (this.history_select[k].field_name === val) {
                return this.history_select[k].value
            }
        }
    }
    getHeader() {
        this.searchList = []
        this.selectList = []
        this.keyList = []
        this.modifyHeader = []
        this.booleanList = []
        this.timeList = []
        for (var i = 0; i < this.header.length; i++) {
            const existsType: string = this.header[i].exists_type
            if (existsType.indexOf('list') >= 0) {
                if (this.header[i].has_search) {
                    const table_name = this.header[i].table_name ? this.header[i].table_name : ''
                    if (this.header[i].data_type === 'string') {
                        let model: string = this.getSearchHistory(this.header[i].key)
                        this.searchList.push({ name: this.header[i].name, model: model, key: this.header[i].key, table_name: table_name })
                    } else if (this.header[i].data_type === 'dict') {
                        let model = this.getSearchHistory(this.header[i].key) ? this.getSearchHistory(this.header[i].key) : []
                        this.selectList.push({ name: this.header[i].name, model: model, option: this.header[i].dict_list, key: this.header[i].key, table_name: table_name })
                    } else if (this.header[i].data_type === 'key_value' || this.header[i].data_type === 'foreign-key') {
                        let optionArr = []
                        for (var k = 0; k < this.optionList[this.header[i].key].length; k++) {
                            if (this.optionList[this.header[i].key][k].is_enabled === 1) {
                                optionArr.push(this.optionList[this.header[i].key][k])
                            } else if (this.optionList[this.header[i].key][k].is_enabled === 0) {

                            } else {
                                optionArr.push(this.optionList[this.header[i].key][k])
                            }
                        }
                        let model = this.getSearchHistory(this.header[i].key) ? this.getSearchHistory(this.header[i].key) : []
                        this.keyList.push({ name: this.header[i].name, model: model, option: optionArr, key: this.header[i].key, table_name: table_name })
                    } else if (this.header[i].data_type === 'boolean') {
                        let model = this.getSearchHistory(this.header[i].key)
                        this.booleanList.push({ name: this.header[i].name, model: model, key: this.header[i].key, table_name: table_name })
                    } else if (this.header[i].data_type === 'number') {
                        let model = this.getSearchHistory(this.header[i].key) ? this.getSearchHistory(this.header[i].key) : undefined
                        this.numberList.push({ name: this.header[i].name, model: model, key: this.header[i].key, table_name: table_name })
                    } else if (this.header[i].data_type === 'datetime') {
                        let model = this.getSearchHistory(this.header[i].key) ? this.getSearchHistory(this.header[i].key) : []
                        if (model[0]) {
                            model[0] = new Date(Number(model[0] * 1000))
                        }
                        if (model[1]) {
                            model[1] = new Date(Number(model[1] * 1000))
                        }
                        this.timeList.push({ name: this.header[i].name, model: model, key: this.header[i].key, table_name: table_name })
                    }
                }
            }
            if (existsType.indexOf('modify') >= 0) {
                this.modifyHeader.push(this.header[i])
            }
        }
        this.is_export_table = false
        if (!this.from) {
            this.onSearch()
        }
        this.isSearch = !!((this.searchList.length > 0) || (this.selectList.length > 0) || (this.keyList.length > 0))
        if (this.allData.page_section && this.allData.page_section[0].has_add_btn) {
            this.isAddButton = true
        } else {
            this.isAddButton = false
        }
        this.isDown = true
        if (this.from === 'business' || this.from === 'student') {
            this.getBusiness()
        }
        if (this.pageName === 'campus-page') {
            this.isMap = true
        }
        if (this.pageName === 'edu-customer-page' || this.pageName === 'edu-student-page' || this.pageName === 'edu-business-page' || this.pageName === 'edu-order-page' || this.pageName === 'edu-clue-page') {
            this.is_show_export = true
        }

        if (this.pageName === 'edu-order-page') {
            let order_id = this.$route.query.order_id
            let option_id = this.$route.query.option_id
            if (order_id && option_id) {
                this.order_info_id = order_id
                this.optionId = option_id
                this.is_show_order_info = true
            }
        }
        this.alertPop()

        this.getSearchHeight()
    }

    handleSelectionChange(val) {
        this.goodsSelectId = []
        for (var i = 0; i < val.length; i++) {
            this.goodsSelectId.push(val[i].id)
        }
    }
    updateGoods(type) {
        let data = {
            status: type,
            id: this.goodsSelectId
        }
        this.getGoodsStatus(data)
    }
    async getGoodsStatus(data) {
        const res: any = await CourseModule.updateGoodsStatus(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.is_export_table = false
            this.updateList()
        } else {
            this.$message.error('修改失败')
        }
    }
    changeInfoStatus(val, row) {
        if (this.pageName === 'edu-goods-page') {  // 仓储物品管理
            if ((row.status).indexOf(val.key) >= 0) {
                return false
            }
            let tip: string = ''
            if (val.key === '0') {
                tip = '将物品设置为仓储物品？'
            } else if (val.key === '1') {
                tip = '将物品设置为出售物品？'
            } else if (val.key === '2') {
                tip = '将物品设置为服役物品？'
            }
            let now_status = ''
            if (Number(val.key) === 0) {
                now_status = '0'
            } else {
                if (row.status === '0') {
                    now_status = val.key
                } else {
                    now_status = val.key + ',' + row.status
                }
            }
            this.$confirm(tip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    status: now_status,
                    id: [row.id]
                }
                this.getGoodsStatus(data)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                })
            })
        } else if (this.pageName === 'edu-goods-use-page' || this.pageName === 'edu-goods-sale-page') {  // 服役物品管理 出售物品
            let tip: string = ''
            if (this.pageName === 'edu-goods-use-page') {
                if (Number(val.key) === row.info2_status) {
                    return false
                }
                if (val.key === '1') {
                    tip = '将物品服役状态修改为服役中？'
                } else if (val.key === '2') {
                    tip = '将物品服役状态修改为已报废？'
                }
            } else if (this.pageName === 'edu-goods-sale-page') {
                if (Number(val.key) === row.info_status) {
                    return false
                }
                if (val.key === '1') {
                    tip = '将物品服役状态修改为已上架？'
                } else if (val.key === '2') {
                    tip = '将物品服役状态修改为已下架？'
                }
            }

            this.$confirm(tip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {}
                if (this.pageName === 'edu-goods-use-page') {
                    data = {
                        info2_status: Number(val.key),
                        id: row.id
                    }
                } else {
                    data = {
                        info_status: Number(val.key),
                        id: row.id
                    }
                }
                this.updateGoodsInfo(data)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                })
            })
        }
    }

    editGoodsDetails(val) {
        if (val.type) {
            this.updateGoodsInfo(val.data)
        }
        this.dialogGoodsInfo = false
    }

    async updateGoodsInfo(data) {
        const res: any = await CourseModule.updateGoodsInfo(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.is_export_table = false
            this.updateList()
        } else {
            this.$message.error('修改失败')
        }
    }

    getBusiness() {
        const key: any = this.$route.query.key
        const value: any = this.$route.query.value
        let time: any = this.$route.query.time
        let campus: any = this.$route.query.campus
        let teacher: any = this.$route.query.teacher
        let instrument: any = this.$route.query.instrument
        if (key === 'ages') {
            this.getKeyList(this.selectList, [value], key)
        } else if (key === 'level_id' || key === 'instrument_type_id' || key === 'course_type_id') {
            this.getKeyList(this.keyList, [value], key)
        } else if (key === 'is_end') {
            this.getKeyList(this.booleanList, value, key)
        } else if (key === 'has_comment') {
            this.getKeyList(this.selectList, [value.toString()], key)
        }
        if (campus) {
            this.getKeyList(this.keyList, JSON.parse(campus), 'campus_id')
        }
        if (instrument && key != 'instrument_type_id') {
            this.getKeyList(this.keyList, JSON.parse(instrument), 'instrument_type_id')
        }
        if (teacher) {
            if (this.pageName === 'edu-customer-page') {
                this.getKeyList(this.keyList, JSON.parse(teacher), 'connect_employee_id')
            } else if (this.pageName === 'edu-business-page' || this.pageName === 'edu-student-page') {
                this.getKeyList(this.keyList, JSON.parse(teacher), 'teacher_id')
            } else if (this.pageName === 'edu-order-page') {
                this.getKeyList(this.keyList, JSON.parse(teacher), 'teacher_employee_id')
            } else {
                this.getKeyList(this.keyList, JSON.parse(teacher), 'teacher_id')
            }
        }
        if (time) {
            this.getKeyList(this.timeList, JSON.parse(time), 'create_time')
        }
        this.is_export_table = false
        this.onSearch()
    }

    getKeyList(arr, item, val) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].key === val) {
                arr[i].model = item
            }
        }
    }
    getColor(type) {
        return learnStatus(type) === 'learn_color_333333' ? '' : learnStatus(type)
    }
    isDeleteButton() {
        if (this.pageName === 'edu-banner-page' || this.pageName === 'edu-clue-page' || this.pageName === 'edu-article-page' || this.pageName === 'edu-agreement-page' || this.pageName === 'edu-about-page') {
            this.is_student_site = true
        }
    }

    async feedbackStatus(val) {
        let data = {
            id: val.id,
            is_handle: val.is_handle
        }
        const res: any = await CourseModule.feedbackStatus(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.$emit('up-status', { type: true })
        } else {
            this.$emit('up-status', { type: false })
            this.$message.error(res.message)
        }
    }
    async eduClueStatus(val) {
        let data = {
            id: val.id,
            is_handle: val.is_handle
        }
        const res: any = await CourseModule.eduClueStatus(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })

            UserModule.GetUserInfo()
            this.$emit('up-status', { type: true })
        } else {
            this.$emit('up-status', { type: false })
            this.$message.error(res.message)
        }
    }

    isHandleChange(val) {
        let tip: string = ''
        if (val.is_handle === 1) {
            tip = '将状态改为已处理？'
        } else {
            tip = '将状态改为未处理？'
        }
        this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            if (this.pageName === 'edu-feedback-page') {
                this.feedbackStatus(val)
            }
        }).catch(() => {
            this.$emit('up-status', { type: false })
            this.$message({
                type: 'info',
                message: '已取消删除'
            })
        })
    }

    async option() {
        const res: any = await CourseModule.options({ optionId: this.optionId, org_id: this.org_id })
        if (res.code === 200) {
            this.optionList = res.data
            this.getHeader()
        }
    }
    getHeight() {
        window.onresize = () => {
            this.tableHeight = window.innerHeight - this.searchHeight - 150
        }
    }
    handleCurrentChange(val) {
        this.pagination_page = val
        const data: any = {
            page: {
                page: val,
                size: '20'
            },
            org_id: this.org_id,
            search_condition: this.searchCondition
        }
        this.is_export_table = false
        this.upList(data)
    }

    getUrl(url, data) {
        const keys = Object.keys(data)
        const dataList = keys.map(function (key) {
            return data[key]
        })
        return new Function(keys.join(','), 'return `' + url + '`;').apply(
            null,
            dataList
        )
    }

    async getCustomerList() {
        const res: any = await CourseModule.customerPage({ org_id: this.org_id })
        if (res.code === 200) {
            const header = res.data.page_section[0].entity.entity_fields
            this.customer_modifyHeader = []
            for (var i = 0; i < header.length; i++) {
                const existsType: string = header[i].exists_type
                if (existsType.indexOf('modify') >= 0) {
                    this.customer_modifyHeader.push(header[i])
                }
            }
            this.customer_optionId = res.data.page_section[0].entity.id
            this.customer_allData = res.data
            this.customer_pageName = res.data.key
            this.customerOption()
        }
    }
    async customerOption() {
        const res: any = await CourseModule.options({ optionId: this.customer_optionId, org_id: this.org_id })
        if (res.code === 200) {
            this.customer_optionList = res.data
            this.customer_dialogAdd = true
        }
    }
    async getCustomerEdit(it, val, key) {
        const customer_id = val.customer_id['key']
        const res: any = await CourseModule.customerDetail({ customer_id: customer_id })
        this.customer_itemValue = res.data[0]
        this.customer_isAddType = 'edit'
        this.getCustomerList()
    }

    goOption(it, val, key) {
        console.log(it)
        console.log(val)
        console.log(key)
        this.itemValue = val
        // 添加套餐下面的基础课程关联
        if (it.button_type === 5) {
            console.log(this.pageName)
            if (this.pageName === 'edu-packet-page') {
                this.getPacketCourse(val)
            }
        }
        if (it.button_type === 6) { // 跳转
            if (this.pageName === 'edu-student-page') {
                this.student_info_id = val.id
                this.is_show_student_info = true
            } else if (this.pageName === 'edu-order-page' && key === 'business_id') {
                this.student_info_id = val.student_id
                this.is_show_student_info = true
            } else if (this.pageName === 'edu-order-page' && key === 'customer_id') {
                this.getCustomerEdit(it, val, key)
            } else {
                let link: string = it.link
                let url: any = this.getUrl(link, val)
                if (url.indexOf('/order/detail?order_id') >= 0) {
                    this.order_info_id = val.id
                    this.is_show_order_info = true
                } else {
                    this.$router.push({ path: url })
                }
            }
        } else if (it.button_type === 2) { // 删除
            this.deleteItem(val)
        } else if (it.button_type === 1) { // 编辑
            if (this.pageName === 'edu-business-page' && key === 'customer_id') {
                this.getCustomerEdit(it, val, key)
            } else if (this.pageName === 'edu-goods-page') {
                this.getGoods(val.id)
            } else if (this.pageName === 'edu-goods-use-page' || this.pageName === 'edu-goods-sale-page') {
                this.getGoodsDetails(val.id)
            } else {
                this.isAddType = 'edit'
                this.dialogAdd = true
            }
        } else if (it.button_type === 4) {
            if (this.pageName === 'campus-page') {
                this.campus_info_id = val.id
                this.is_show_campus_info = true
            } else if (this.pageName === 'edu-employee-page') {
                this.employee_info_id = val.id
                this.is_show_employee_info = true
            }
        }
    }
    // 根据id获取服役出售物品当前数据
    async getGoodsDetails(id) {
        const res: any = await CourseModule.getGoodsDetails({ id: id })
        if (res.code === 200) {
            this.GoodsDetailsInfo = res.data
            this.dialogGoodsInfo = true
            this.goodsPageType = this.pageName
        }
    }
    // 根据id获取仓储物品当前数据
    async getGoods(id) {
        const res: any = await CourseModule.getGoods({ id: id })
        if (res.code === 200) {
            this.goodsItem = res.data
            this.storageShow = true
            this.isAddType = 'edit'
        }
    }

    async delete(val) {
        const data = {
            data_id: val.id,
            org_id: this.org_id
        }
        const res: any = await CourseModule.deleteItem({ data: data, optionId: this.optionId })
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            const list = {
                page: {
                    page: '1',
                    size: '20'
                },
                org_id: this.org_id,
                search_condition: this.searchCondition
            }
            this.is_export_table = false
            this.upList(list)
        } else {
            this.$message.error('删除失败！')
        }
    }

    deleteItem(val) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.delete(val)
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            })
        })
    }
    addItem() {
        if (this.pageName === 'edu-goods-page') {
            this.isAddType = 'add'
            this.storageShow = true
        } else {
            this.isAddType = 'add'
            this.dialogAdd = true
        }
    }

    onSearch() {
        this.searchCondition = []
        //  input框搜索
        for (var i = 0; i < this.searchList.length; i++) {
            if (this.searchList[i].model) {
                this.searchCondition.push({ field_name: this.searchList[i].key, value: this.searchList[i].model, search_type: 1, table_name: this.searchList[i].table_name })
            }
        }
        //  header中自带选项
        for (var i = 0; i < this.selectList.length; i++) {
            if (this.selectList[i].model.length > 0) {
                this.searchCondition.push({ field_name: this.selectList[i].key, value: this.selectList[i].model, search_type: 0, table_name: this.selectList[i].table_name })
            }
        }
        //  需要去option接口中找选项
        for (var i = 0; i < this.keyList.length; i++) {
            if (this.keyList[i].model.length > 0) {
                this.searchCondition.push({ field_name: this.keyList[i].key, value: this.keyList[i].model, search_type: 0, table_name: this.keyList[i].table_name })
            }
        }
        //  boolean
        for (var i = 0; i < this.booleanList.length; i++) {
            if (this.booleanList[i].model > 0) {
                this.searchCondition.push({ field_name: this.booleanList[i].key, value: this.booleanList[i].model, search_type: 0 })
            } else {
                if (this.booleanList[i].model === 0) {
                    this.searchCondition.push({ field_name: this.booleanList[i].key, value: this.booleanList[i].model, search_type: 0 })
                }
            }
        }
        //  数量
        for (var i = 0; i < this.numberList.length; i++) {
            if (this.numberList[i].model >= 0) {
                this.searchCondition.push({ field_name: this.numberList[i].key, value: this.numberList[i].model, search_type: 0 })
            } else {
                this.searchCondition.push({ field_name: this.numberList[i].key, search_type: 0 })
            }
        }
        //  时间
        for (var i = 0; i < this.timeList.length; i++) {
            if (this.timeList[i].model && this.timeList[i].model.length > 0) {
                const start = Date.parse(this.timeList[i].model[0]) / 1000
                const end = Date.parse(this.timeList[i].model[1]) / 1000
                this.searchCondition.push({ field_name: this.timeList[i].key, value: [start, end], search_type: 2 })
            }
        }
        this.updateList()
    }

    async upList(data) {
        this.loading = true
        if (this.sortItem.prop) {
            let sort: any =
            {
                field_name: this.sortItem.prop.split(',')[0],
                order: this.sortItem.order === 'ascending' ? 'asc' : 'desc',
                table_name: this.sortItem.prop.split(',')[1] === 'null' ? '' : this.sortItem.prop.split(',')[1]
            }
            if (this.sortItem.order) {
                data['sort'] = sort
            }
        }
        if (this.is_export_table) {  // 导出
            this.loading = false
            let time: any = new Date()
            let t: any = Date.parse(time) / 1000
            const res: any = await CourseModule.exportCourse({ data: data, upId: this.upListId, t: t })
            const link = document.createElement('a')
            const blob = new Blob([res.data], { type: 'application/x-excel' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.download = res.fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } else {  // 搜索
            const res: any = await CourseModule.updataCourse({ data: data, upId: this.upListId })
            if (res.code === 200) {
                this.listPage = res.data.entity.page
                this.allData.history_select = res.data.history_select
                this.allData.entity = res.data
                this.$emit('up-list', { data: res.data.entity.entity_data, allData: this.allData })
            }
        }
    }
    sortChange(val) {
        this.sortItem = val
        this.is_export_table = false
        this.updateList()
    }

    addSuccess(val) {
        this.option()
        this.dialogAdd = false
        this.customer_dialogAdd = false
        this.is_export_table = false
        this.updateList()
    }

    async getPacket(val) {
        this.listDetailId = val.id
        this.listDetailType = 'theme'
        const res = await CourseModule.getSubject({ packet_id: val.id })
        this.detailTitle = res.data[0].packet_name + '所包含的主题'
        this.detailList = res.data
        for (var i = 0; i < this.detailList.length; i++) {
            this.detailList[i]['list_index'] = i + 1
        }
        this.detailHeader = [
            {
                name: '序号',
                prop: 'list_index',
                width: '50'
            },
            {
                name: '主题名',
                prop: 'name',
                width: ''
            },
            {
                name: '适合人群',
                prop: 'crowd_type_str',
                width: ''
            },
            {
                name: '乐器类型',
                prop: 'instrument_type_name',
                width: ''
            },
            {
                name: '主题难度阶段',
                prop: 'difficulty_str',
                width: ''
            }
        ]
        this.dialogListDetail = true
    }

    async getPacketCourse(val) {
        /**
         * 获取套餐里面设置基础课程的 1人/扣减课次
         * */
        this.packetBasecourseList = []
        console.log(val)
        console.log("getPacketCourse")
        this.packetBasecourseID = val.id
        this.packetBasecourseType = 'packet_course'
        const res = await CourseModule.getPacketBaseCourse({ packet_id: val.id })
        this.packetBasecourseTitle = val.name + '所包含的课程'
        this.packetBasecourseName = val.name
        this.packetBasecourseList = res.data
        this.defaultCourseId = val.base_course_id.key
        for (var i = 0; i < this.packetBasecourseList.length; i++) {
            this.packetBasecourseList[i]['list_index'] = i + 1
        }
        this.packetBasecourseHeader = [
            {
                name: '乐器类型',
                prop: 'instrument_type_name',
                width: '150'
            },
            {
                name: '课程',
                prop: 'name',
                width: '150'
            },
            {
                name: '可见预约人数',
                prop: 'is_enabled_show',
                width: '100'
            },
            {
                name: '最大学生数',
                prop: 'student_count',
                width: '100'
            }
        ]
        for (let i = 1; i < 11; i++) {
            const item = {
                "name": `${i}人:扣减课次`,
                "prop": `time_${i}`,
                "width": '100'
            }
            this.packetBasecourseHeader.push(item)
        }
        this.dialogPacketBaseCourse = true
    }


    // 切换类型判断
    changeHandle(item, row) {
        if (this.pageName === 'edu-feedback-page' && item.key === 'is_handle') {
            let text = ''
            if (row.is_handle === 0) {
                text = '已处理'
            } else {
                text = '未处理'
            }
            this.$confirm(`是否变更状态为${text}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let data = {
                    id: row.id,
                    is_handle: row.is_handle === 0 ? 1 : 0
                }
                this.getHandle(data)
            }).catch(() => { })
        } else if (this.pageName === 'edu-clue-page' && item.key === 'is_handle') {
            let text = ''
            if (row.is_handle === 0) {
                text = '已处理'
            } else {
                text = '未处理'
            }
            this.$confirm(`是否变更状态为${text}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let data = {
                    id: row.id,
                    is_handle: row.is_handle === 0 ? 1 : 0
                }
                this.eduClueStatus(data)
            }).catch(() => { })
        } else if (this.pageName === 'edu-business-page' && item.key === 'is_connect') {
            let text = ''
            if (row.is_connect === 0) {
                text = '已联系'
            } else {
                text = '未联系'
            }
            this.$confirm(`是否变更状态为${text}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let data = {
                    id: row.id,
                    is_connect: row.is_connect === 0 ? 1 : 0
                }
                this.eduBusinessStatus(data)
            }).catch(() => { })
        } else if (item.key === 'is_enabled') {
            let text = ''
            if (row.is_enabled === 0) {
                text = '启用'
            } else {
                text = '禁用'
            }
            this.$confirm(`是否变更状态为${text}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let data = {
                    data_id: row.id,
                    data: {
                        is_enabled: row.is_enabled === 0 ? 1 : 0
                    }
                }
                this.editItemEnabled(data)
            }).catch(() => { })
        }
    }
    async eduBusinessStatus(data) {
        const res: any = await CourseModule.editItemConnect({ data: data, optionId: this.optionId })
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.is_export_table = false
            this.updateList()
        } else {
            this.$message({
                type: 'error',
                message: '修改失败'
            })
        }
    }
    async editItemEnabled(data) {
        const res: any = await CourseModule.editItemEnabled({ data: data, optionId: this.optionId })
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.is_export_table = false
            this.updateList()
        } else {
            this.$message({
                type: 'error',
                message: '修改失败'
            })
        }
    }
    async getHandle(data) {
        const res: any = await CourseModule.putFeedback(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.is_export_table = false
            this.updateList()
        } else {
            this.$message({
                type: 'error',
                message: '修改失败'
            })
        }
    }

    //  主题类型管理/主题要点
    async getEssential(val) {
        this.listDetailId = val.id
        this.listDetailType = 'points'
        const res = await CourseModule.getEssentialList({ subject_id: val.id })
        this.detailTitle = res.data[0].subject_name + '所包含的要点'
        this.detailList = res.data
        for (var i = 0; i < this.detailList.length; i++) {
            this.detailList[i]['list_index'] = i + 1
        }
        this.detailHeader = [
            {
                name: '序号',
                prop: 'list_index',
                width: '50'
            },
            {
                name: '要点名称',
                prop: 'name',
                width: ''
            },
            {
                name: '要点内容',
                prop: 'content',
                width: ''
            },
            {
                name: '参考课时',
                prop: 'class_hours',
                width: '100'
            },
            {
                name: '要点素材',
                prop: 'essential_material',
                width: ''
            }
        ]
        this.dialogListDetail = true
    }
    detailClose(val) {
        if (!val.type) {
            this.dialogListDetail = false
            this.updateList()
        }
    }

    packetBaseCourseClose(val) {
        this.dialogPacketBaseCourse = false
        this.updateList()
    }

    async readAgree() {
        const res: any = await CourseModule.readAgreement()
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '操作成功!'
            })
        } else {
            this.$message({
                type: 'error',
                message: '操作失败'
            })
        }
    }

    readAgreement() {
        this.$confirm('所有学员登录时重新查看约课协议？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.readAgree()
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '取消操作'
            })
        })
    }
    getSearchHeight() {
        this.$nextTick(function () {
            this.searchHeight = document.getElementById('search').offsetHeight
            this.tableHeight = window.innerHeight - this.searchHeight - 150
        })
    }

    mounted() {
        this.from = this.$route.query.from
        this.alert = this.$route.query.alert   // 试听课 - 跳转 - 新建订单
        this.getHeight()
    }
}
